import React from 'react';
interface Props {
  variant?: 'light' | 'dark';
  className?: string;
  size?: 'sm' | 'md';
}
/**
 * Elegant "Powered by RTA" attribution badge.
 * Used across customer and carrier portals to signal RTA partnership.
 */
export function PoweredByRTA({
  variant = 'light',
  className = '',
  size = 'sm'
}: Props) {
  const isDark = variant === 'dark';
  const captionColor = isDark ? 'text-gray-300' : 'text-gray-400';
  const subCaptionColor = isDark ? 'text-gray-500' : 'text-gray-300';
  const dividerColor = isDark ? 'bg-white/20' : 'bg-gray-200';
  const logoHeight = size === 'sm' ? 'h-6' : 'h-8';
  return <div className={`inline-flex items-center gap-2.5 ${className}`} title="In partnership with Roads & Transport Authority" data-id="element-371">
      <div className="flex flex-col items-end leading-none" data-id="element-372">
        <span className={`text-[8px] font-bold uppercase tracking-[0.18em] ${captionColor}`} data-id="element-373">
          Powered by
        </span>
        <span className={`text-[8px] font-medium tracking-wider ${subCaptionColor} mt-0.5`} data-id="element-374">
          Official Partner
        </span>
      </div>
      <div className={`w-px h-7 ${dividerColor}`} data-id="element-375" />
      {isDark ? <div className="bg-white rounded-md px-2 py-1 shadow-sm" data-id="element-376">
          <img src="https://cdn.magicpatterns.com/uploads/r7wfEYdYHquh6ssKsJKQk5/RTA-LOGO-1.png" alt="Roads & Transport Authority" className={`${logoHeight} w-auto object-contain`} data-id="element-377" />
        </div> : <img src="https://cdn.magicpatterns.com/uploads/r7wfEYdYHquh6ssKsJKQk5/RTA-LOGO-1.png" alt="Roads & Transport Authority" className={`${logoHeight} w-auto object-contain`} data-id="element-378" />}
    </div>;
}